import React from "react";
import { tokens } from "../../theme/theme";
import { Divider, Typography, Card, CardContent, Grid, CardHeader, IconButton, Button, useTheme, Box, } from "@mui/material";
import QrCodeScannerIcon from '@mui/icons-material/QrCodeScanner';
import SettingsSuggestIcon from '@mui/icons-material/SettingsSuggest';

// icons 

import Inventory2OutlinedIcon from '@mui/icons-material/Inventory2Outlined';
import InventoryOutlinedIcon from '@mui/icons-material/InventoryOutlined';
import NoteOutlinedIcon from '@mui/icons-material/NoteOutlined';
import FormatOverlineOutlinedIcon from '@mui/icons-material/FormatOverlineOutlined';
import ContentCutOutlinedIcon from '@mui/icons-material/ContentCutOutlined';
import CommitOutlinedIcon from '@mui/icons-material/CommitOutlined';
import ScatterPlotOutlinedIcon from '@mui/icons-material/ScatterPlotOutlined';
import LooksOutlinedIcon from '@mui/icons-material/LooksOutlined';
import Header from "../../Layout/Header";
import { useTranslation } from "react-i18next";

const MasterMenu = ({ SetActive, handleBackDashboard }) => {

    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const { t, i18n } = useTranslation();

    const callback = () => {
        handleBackDashboard();
    };

    return (
        <Box >
            <Card sx={{ backgroundColor: "transparent" }}>
                <CardContent>
                    <Box display="flex" justifyContent="space-between" alignItems="center">

                        <Typography variant="h4" color={colors.grey[100]} fontWeight="bold" justifyContent="center">Masters </Typography>
                    </Box>

                </CardContent>
            </Card>






            {/* <Divider /> */}
            <Box p={2}>
                <Grid container spacing={2} justifyContent="start" marginTop="10px"  >
                    <Grid item xs={12} sm={6} md={4} lg={3}>
                        <Card sx={{ backgroundColor: colors.primary[400], p: 2, borderRadius: 2, textAlign: "center" }}>
                            {/* <FormatOverlineOutlinedIcon fontSize="large" /> */}
                            <Typography variant="h6" mt={2}>Party Master</Typography>
                            <Button variant="contained" color="secondary" sx={{ mt: 2 }} onClick={() => SetActive("PartyMaster")}>View</Button>
                        </Card>
                    </Grid>



                    <Grid item xs={12} sm={6} md={4} lg={3}>
                        <Card sx={{ backgroundColor: colors.primary[400], p: 2, borderRadius: 2, textAlign: "center" }}>
                            {/* <LooksOutlinedIcon fontSize="large" /> */}
                            <Typography variant="h6" mt={2}>Product Master</Typography>
                            <Button variant="contained" color="secondary" sx={{ mt: 2 }} onClick={() => SetActive("ProductMaster")}>View</Button>
                        </Card>
                    </Grid>


                    <Grid item xs={12} sm={6} md={4} lg={3}>
                        <Card sx={{ backgroundColor: colors.primary[400], p: 2, borderRadius: 2, textAlign: "center" }}>
                            {/* <FormatOverlineOutlinedIcon fontSize="large" /> */}
                            <Typography variant="h6" mt={2}>Machine Master</Typography>
                            <Button variant="contained" color="secondary" sx={{ mt: 2 }} onClick={() => SetActive("MachineMaster")}>View</Button>
                        </Card>
                    </Grid>
                    <Grid item xs={12} sm={6} md={4} lg={3}>
                        <Card sx={{ backgroundColor: colors.primary[400], p: 2, borderRadius: 2, textAlign: "center" }}>
                            {/* <FormatOverlineOutlinedIcon fontSize="large" /> */}
                            <Typography variant="h6" mt={2}>Remarks Master</Typography>
                            <Button variant="contained" color="secondary" sx={{ mt: 2 }} onClick={() => SetActive("RemarksMaster")}>View</Button>
                        </Card>
                    </Grid>
                     <Grid item xs={12} sm={6} md={4} lg={3}>
                        <Card sx={{ backgroundColor: colors.primary[400], p: 2, borderRadius: 2, textAlign: "center" }}>
                            {/* <FormatOverlineOutlinedIcon fontSize="large" /> */}
                            <Typography variant="h6" mt={2}>Bank Master</Typography>
                            <Button variant="contained" color="secondary" sx={{ mt: 2 }} onClick={() => SetActive("BankMaster")}>View</Button>
                        </Card>
                    </Grid>
                    <Grid item xs={12} sm={6} md={4} lg={3}>
                        <Card sx={{ backgroundColor: colors.primary[400], p: 2, borderRadius: 2, textAlign: "center" }}>
                            {/* <FormatOverlineOutlinedIcon fontSize="large" /> */}
                            <Typography variant="h6" mt={2}>OverTime Master</Typography>
                            <Button variant="contained" color="secondary" sx={{ mt: 2 }} onClick={() => SetActive("OverTimeMaster")}>View</Button>
                        </Card>
                    </Grid>

                     <Grid item xs={12} sm={6} md={4} lg={3}>
                        <Card sx={{ backgroundColor: colors.primary[400], p: 2, borderRadius: 2, textAlign: "center" }}>
                            {/* <FormatOverlineOutlinedIcon fontSize="large" /> */}
                            <Typography variant="h6" mt={2}>Operator</Typography>
                            <Button variant="contained" color="secondary" sx={{ mt: 2 }} onClick={() => SetActive("Operator")}>View</Button>
                        </Card>
                    </Grid>

                    
                     <Grid item xs={12} sm={6} md={4} lg={3}>
                        <Card sx={{ backgroundColor: colors.primary[400], p: 2, borderRadius: 2, textAlign: "center" }}>
                            {/* <FormatOverlineOutlinedIcon fontSize="large" /> */}
                            <Typography variant="h6" mt={2}>QC Property Master</Typography>
                            <Button variant="contained" color="secondary" sx={{ mt: 2 }} onClick={() => SetActive("QCProperty")}>View</Button>
                        </Card>
                    </Grid>


 <Grid item xs={12} sm={6} md={4} lg={3}>
                        <Card sx={{ backgroundColor: colors.primary[400], p: 2, borderRadius: 2, textAlign: "center" }}>
                            {/* <FormatOverlineOutlinedIcon fontSize="large" /> */}
                            <Typography variant="h6" mt={2}>Repulp Waste Type Master</Typography>
                            <Button variant="contained" color="secondary" sx={{ mt: 2 }} onClick={() => SetActive("RepulpWasteMaster")}>View</Button>
                        </Card>
                    </Grid>


<Grid item xs={12} sm={6} md={4} lg={3}>
                        <Card sx={{ backgroundColor: colors.primary[400], p: 2, borderRadius: 2, textAlign: "center" }}>
                            {/* <FormatOverlineOutlinedIcon fontSize="large" /> */}
                            <Typography variant="h6" mt={2}>Repulp Waste Location Master</Typography>
                            <Button variant="contained" color="secondary" sx={{ mt: 2 }} onClick={() => SetActive("RepulpWasteLocationMaster")}>View</Button>
                        </Card>
                    </Grid>







                </Grid>
            </Box>
        </Box>

    )
}
export default MasterMenu;